import MessageBanner from 'LuxKit/Banners/MessageBanner'
import TextButton from 'LuxKit/Button/TextButton'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import MultiCartOfferComparisonModal from './Modal/MultiCartOfferComparisonModal'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { rem } from 'polished'
import React, { useContext, useMemo } from 'react'
import styled from 'styled-components'
import { MultiCartContext } from 'machines/cart/MultiCartMachineProvider'
import { useSelector } from '@xstate/react'
import { isSpoofed } from 'selectors/featuresSelectors'

const StyledMobileContainer = styled(Group)`
  padding: 0 ${rem(16)};
`

function MultiCartComparisonBanner() {
  const showModal = useContext(ModalContext)
  const isSpoofedEnabled = useAppSelector(isSpoofed)

  const multiCartActorRef = MultiCartContext.useActorRef()
  const { cartActiveComparison } = useSelector(multiCartActorRef, (snapshot) => ({
    cartActiveComparison: snapshot.context.cartActiveComparisons.status === 'loaded' && snapshot.context.activeCartId
      ? snapshot.context.cartActiveComparisons.data[snapshot.context.activeCartId] || []
      : [],
  }))

  const showUserCartComparisonBanner = useMemo(() => (
    !isSpoofedEnabled && cartActiveComparison && cartActiveComparison.length > 0
  ), [isSpoofedEnabled, cartActiveComparison])

  const openComparisonModal = () => {
    showModal(<MultiCartOfferComparisonModal mode="user-cart" />)
  }

  if (!showUserCartComparisonBanner) {
    return null
  }

  return (
    <>
      <CSSBreakpoint min="tablet">
        <MessageBanner
          kind="informational-primary"
          icon={<LinePhoneIcon />}
          heading="Your agent has shared a tailored comparison"
          primaryActionButtonProps={{
            children: 'View comparison',
            onClick: openComparisonModal,
            shape: 'round',
          }}
        >
          Side-by-side comparison to help you decide.
        </MessageBanner>
      </CSSBreakpoint>
      <CSSBreakpoint max="mobile">
        <StyledMobileContainer direction="horizontal" gap={8}>
          <LinePhoneIcon />
          <Group direction="vertical" horizontalAlign="start" gap={8}>
            <Group direction="vertical" gap={4}>
              <BodyText variant="medium" weight="bold">Your agent has shared a tailored comparison</BodyText>
              <BodyText variant="medium">Side-by-side comparison to help you decide.</BodyText>
            </Group>
            <TextButton kind="secondary" shape="round" onClick={openComparisonModal}>View comparison</TextButton>
          </Group>
        </StyledMobileContainer>
      </CSSBreakpoint>
    </>
  )
}

export default MultiCartComparisonBanner
